<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-11-06 09:16:48
 * @LastEditors: mrh
 * @LastEditTime: 2020-11-09 17:54:11
-->
<template>
  <van-pull-refresh v-model="isDownLoading" @refresh="onPullDownRefresh">
    <van-list
      v-model="isUpLoading"
      :finished="finished"
      :finished-text="!lists.length ? '' : '没有更多了'"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onReachBottom"
    >
      <div class="lists">
        <div
          v-for="(item, index) in lists"
          :key="index"
          @click="setRead(item.id,item.skipId)"
        >
          <div>
            <span>
              {{ item.title }}
            </span>
            <span>
              {{ item.pushTime }}
            </span>
          </div>
          <div>
            {{ item.content }}
          </div>
          <span v-show="item.isRead == 0"></span>
        </div>
      </div>
    </van-list>
    <div v-show="!lists.length && !isUpLoading && !error" class="nulls">
      <i class="iconfont icon-personal_image_nosto1"></i>
      <span>暂时没有记录哦</span>
    </div>
  </van-pull-refresh>
</template>

<script>
import { afterSaleMsg, setRead } from "@/api/join";
export default {
  data() {
    return {
      lists: [],
      pages: 1, //分页页码
      isDownLoading: false, // 下拉刷新加载状态（true处于加载状态）
      isUpLoading: false, // 上拉加载状态（true处于加载状态）
      finished: true, // 数据全部加载状态（true为数据全部加载完毕,不再请求数据接口）
      pageIndex: 1, // 分页页数
      error: false, // 是否加载失败状态（true为加载失败）
    };
  },
  methods: {
    afterSaleMsg() {
      let obj = {
        page: {
          way: "1", // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pages, // 请求页数，index = 1 表示第一页
          size: "10", //数量
        },
        type: "5",
      };
      afterSaleMsg(obj)
        .then((res) => {
          if (res.appStatus.errorCode == 0) {
            // console.log("3");
            if (this.lists.length < 10) {
              // 最后一页不足10条的情况
              this.finished = true;
            }
            if (this.pages == 1) {
              this.lists = res.content.list;
            } else {
              this.lists = [...res.content.list, ...this.lists];
            }
            this.pages++;
          } else {
            this.error = true;
          }
          this.isDownLoading = false;
          this.isUpLoading = false;
          this.getNowFormatDate();
        })
        .catch((res) => {
          this.error = true;
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    setRead(id,sid) {
      setRead({ id }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$router.push({
            path: "/orderDetails",
            query: {
              orderId: sid,
            },
          });
        }
      });
    },
    // 下拉刷新
    onPullDownRefresh() {
      this.pages = 1;
      this.lists = [];
      this.error = false;
      this.finished = false;
      this.isDownLoading = false;
      // 重新加载数据
      // 将 isUpLoading 设置为 true，表示处于加载状态
      this.isUpLoading = true;
      this.afterSaleMsg();
    },
    // 上拉加载
    onReachBottom() {
      this.afterSaleMsg();
    },
    getNowFormatDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let weekday = date.getDate();
      let hour = date.getHours();
      let min = date.getMinutes();
      let sec = date.getSeconds();
      if (month < 10) {
        month = '0' + month;
      }
      if (weekday < 10) {
        weekday = '0' + weekday;
      }
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (min < 10) {
        min = '0' + min;
      }
      if (sec < 10) {
        sec = '0' + sec;
      }
      localStorage.setItem("leastOpenTime", year + '-' + month + '-' + weekday + ' ' + hour + ':' + min + ':' + sec);
    },
  },
  mounted() {
    this.afterSaleMsg();
  },
};
</script>

<style lang="scss" scoped>
.lists {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  display: inline-block;
  > div {
    width: 335px;
    min-height: 50px;
    background: #fff;
    margin: 10px auto 0;
    padding: 10px;
    border-radius: 10px;
    position: relative;
    > div {
      color: #1d1d1d;
      font-size: 15px;
      display: flex;
      > span:last-child {
        // color: #1D1D1D;
        margin-left: auto;
      }
    }
    > div:nth-child(2) {
      margin-top: 10px;
    }
    > span {
      width: 13px;
      height: 13px;
      display: block;
      background: #ff1310;
      border: 1.04px solid #ffffff;
      border-radius: 7px;
      position: absolute;
      right: -5px;
      top: -5px;
    }
  }
}
.nulls {
  .icon-personal_image_nosto1 {
    font-size: 100px;
    color: #d5d5d5;
    display: table;
    margin: 200px auto 0;
  }
  span{
      color: #d5d5d5;
      font-size: 16px;
      display: table;
      margin: 6px auto 0;
  }
}

.van-pull-refresh {
  overflow: initial !important;
  .van-list {
    background: #f5f5f5;
  }
}
</style>